import { render, staticRenderFns } from "./reprintbukutabungan.vue?vue&type=template&id=044d613a"
import script from "./reprintbukutabungan.vue?vue&type=script&lang=js"
export * from "./reprintbukutabungan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports